export enum InterpolationType { Gradient, Fixed, Rainbow };

export interface IColorScale {
    extendAbove?: number;
    extendBelow?: number;
    name: string;
    spaceId?: number;
    description?: string;
    lookupKeys?: number[];
    colors: number[]; // 2n colors
    values?: number[]; // n + 1 values    
    types: InterpolationType[]; // n interpolation types
    hasFixedValues: boolean; // if values is undefined colorscale is strechted on given shallow / deep
    displayCategory?: number;
}